import { StyleSheet, View } from 'react-native';
import { RoutinesList } from './routinesList';

type RoutineFoldProps = {
  maxHeight: number;
};

export const RoutineFold = (props: RoutineFoldProps) => {
  const heightStyle = { maxHeight: props.maxHeight };
  const listMaxHeight = props.maxHeight && props.maxHeight;

  return (
    <View style={[heightStyle, styles.pageContainer]}>
      <View style={styles.foldContainer}>
        <View style={{ width: '100%' }}>
          <RoutinesList listMaxHeight={listMaxHeight} />
        </View>
        <View style={styles.gutter} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  pageContainer: {
    flex: 1,
  },
  foldContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  gutter: {
    width: 24,
  },
});

export default RoutineFold;
